export default "__VITE_ASSET__Bg_gaKMB__"